import script from "./TopHeaderBg.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeaderBg.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./TopHeaderBg.vue?vue&type=style&index=0&id=7b41c3fe&module=header&lang=css"
cssModules["header"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__